import { _Button } from "./_Button";
import { CascadiaButtonProps } from "./types";

interface Props extends CascadiaButtonProps {}

export function FixedNavigationButton(props: Props) {
  return (
    <_Button
      color="text-base"
      fill="background-accent-neutral-weak"
      focusStyle="focus-action"
      hoverFill="background-accent-neutral-weak"
      iconColor="icon-base"
      shadow="shadow-button"
      loaderColor="icon-success"
      shape="border-radius-half"
      {...props}
    />
  );
}
